export default __webpack_public_path__ + "static/media/logo.48afd706.png";